import { uri } from '../../api-endpoint';
import { ILoginAPIValidationError } from '../../type-conversion/login/from-api-repsonse';
import { IUserFromAPISuccessResponse } from '../../type-conversion/user/from-api-response';
import { UserAPIRequestBodyPartial } from '../../type-conversion/user/to-api-request-body';
import { updatePartiallyTemplateFn } from '../common';

export const updateUserPartially = (token: string) => (userId: number) =>
  updatePartiallyTemplateFn(
    token,
    uri.accountById(userId),
    UserAPIRequestBodyPartial,
    IUserFromAPISuccessResponse,
    ILoginAPIValidationError
  );
